import { atom } from 'jotai';

export interface SelectedObjectState {
  objectId: string;
  type: string;
  x: number;
  y: number;
  width: number;
  height: number;
  angle: number;
  opacity: number;
  fill: string;
  stroke: string;
  strokeWidth: number;
  // Text-specific
  text: string;
  fontSize: number;
  fontFamily: string;
  fontWeight: string;
  fontStyle: string;
  lineHeight: number;
  charSpacing: number;
  // Banner CTA
  href?: string;
}

export const editorSelectionAtom = atom<SelectedObjectState | null>(null);
editorSelectionAtom.debugLabel = 'slide-editor/editorSelectionAtom';
